export default __webpack_public_path__ + "static/media/s_facebook_d.320fade9.svg";